export const FETCH_CITIES = 'FETCH_CITIES'
export const FETCH_CITIES_SUCCESS = 'FETCH_CITIES_SUCCESS'
export const FETCH_CITIES_ERROR = 'FETCH_CITIES_ERROR'

export const FETCH_REGIONS = 'FETCH_REGIONS'
export const FETCH_REGIONS_SUCCESS = 'FETCH_REGIONS_SUCCESS'
export const FETCH_REGIONS_ERROR = 'FETCH_REGIONS_ERROR'

export const SEARCH_CITIES = 'SEARCH_CITIES'
export const SEARCH_CITIES_SUCCESS = 'SEARCH_CITIES_SUCCESS'
export const SEARCH_CITIES_ERROR = 'SEARCH_CITIES_ERROR'
